<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div>
          <ImageModal
            :CurrentObject="product.product_edit"
            EntityType="Product"
          >
            <div slot="header">
              <h2>{{ product.product_edit.ProductName }}</h2>
            </div>
            <div slot="body">
              <img style="max-width: 730px;" v-bind:src="selectedImageUrl" />
            </div>
            <div slot="details">
              <div>{{ product.product_edit.ProductShortDesc }}</div>
            </div>
            <span slot="entityType">Product</span>
          </ImageModal>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <div>
          <ProductTagDialog
            :myIteration="componentKey"
            @filterList="myLoadComponent"
          >
            <div slot="header">
              <!-- <h2>{{ mySelected.Quantity }}</h2> -->
            </div>
            <div slot="details">
              <!-- <div>{{ mySelected.Description }}</div> -->
            </div>
          </ProductTagDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Product Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      my_warning: $v.product.product_edit.ProductName.$error
                    }"
                    v-model="product.product_edit.ProductName"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="ProductName"
                    @input="$v.product.product_edit.ProductName.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >SKU</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      my_warning: $v.product.product_edit.ProductSku.$error
                    }"
                    v-model="product.product_edit.ProductSku"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="ProductSku"
                    @input="$v.product.product_edit.ProductSku.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Price (in points)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      my_warning: $v.product.product_edit.BaseUnitCost.$error
                    }"
                    v-model="product.product_edit.BaseUnitCost"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="BaseUnitCost"
                    v-mask="'##########'"
                    @input="$v.product.product_edit.BaseUnitCost.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Wholesale Cost</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      my_warning:
                        $v.product.product_edit.WholesaleUnitCost.$error
                    }"
                    v-model="product.product_edit.WholesaleUnitCost"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="WholesaleUnitCost"
                    @input="$v.product.product_edit.WholesaleUnitCost.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Min Order Qty</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="product.product_edit.MinOrderQuantity"
                    autocomplete="off"
                    type="text"
                    id="MinOrderQuantity"
                    v-mask="'##########'"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Max Order Qty</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="product.product_edit.MaxOrderQuantity"
                    autocomplete="off"
                    type="text"
                    id="MaxOrderQuantity"
                    v-mask="'##########'"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Reorder Level</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="product.product_edit.ReorderLevel"
                    autocomplete="off"
                    type="text"
                    id="ReorderLevel"
                    v-mask="'##########'"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <c-switch
                width="100px"
                class="mx-3 pt-2"
                color="success"
                variant="pill"
                id="IsSplit"
                v-model="product.product_edit.Active"
              />
              <span v-if="product.product_edit.Active" class="text-success bold"
                >Available For Ordering</span
              >
              <span v-if="!product.product_edit.Active" class="text-danger bold"
                >Not Available For Ordering</span
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Short Description<br />({{ ShortDescRemaining }} chars
                      left)
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-textarea
                    rows="2"
                    max-rows="2"
                    no-scroll
                    v-model="product.product_edit.ProductShortDesc"
                    autocomplete="off"
                    type="text"
                    id="ProductShortDesc"
                    v-on:change.native="addDirtyField"
                    maxlength="100"
                    no-resize
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Full Description<br />({{ LongDescRemaining }} chars
                      left)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-textarea
                    no-resize
                    no-scroll
                    rows="4"
                    max-rows="4"
                    v-model="product.product_edit.ProductDesc"
                    autocomplete="off"
                    type="text"
                    id="ProductDesc"
                    v-on:change.native="addDirtyField"
                    maxlength="500"
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div class="form-group form-actions" style="float:left;">
                <b-button
                  v-if="product.product_edit.ProductID > 0"
                  class="mr-2 mt-2"
                  style="color: white;"
                  size="md"
                  variant="orange active"
                  @click="DashRouteTo('/inventory/transactions')"
                  >Inventory Transactions</b-button
                >
              </div>
              <div class="form-group form-actions" style="float:right;">
                <b-button
                  class="mr-2 mt-2"
                  size="md"
                  variant="outline-primary"
                  @click="back"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Cancel
                </b-button>
                <b-button
                  class="mr-0 mt-2"
                  size="md"
                  variant="primary"
                  type="submit"
                  :disabled="isClean"
                >
                  <i class="fa fa-save"></i>
                  Save
                </b-button>
              </div>
              <div class="form-group form-actions" style="float:right;">
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismissCountDown"
                  fade
                  variant="light"
                  :dismissed="(dismissCountdown = 0)"
                  @dismiss-count-down="countDownChanged"
                >
                  Your information has been saved
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss2CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss2Countdown = 0)"
                  @dismiss-count-down="countDown2Changed"
                >
                  Your information could not be saved. Check all fields
                  carefully.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss3CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss3Countdown = 0)"
                  @dismiss-count-down="countDown3Changed"
                >
                  Product already exists! Your information could not be saved.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="product.product_edit.ProductID !== -1" class="mt-4">
            <b-col lg="12">
              <b-tabs>
                <b-tab active>
                  <template slot="title">
                    <i class="fa fa-circle-info"></i>
                    <span class="ml-1">Packaging Specifications</span>
                  </template>
                  <b-row>
                    <b-col md="12">
                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-input-group-text class="standardizedWidth"
                              >Length (inches)</b-input-group-text
                            >
                          </b-input-group-prepend>
                          <b-form-input
                            :class="{
                              my_warning:
                                $v.product.product_edit.ProductLength.$error
                            }"
                            v-model="product.product_edit.ProductLength"
                            autocomplete="off"
                            type="text"
                            id="ProductLength"
                            @input="
                              $v.product.product_edit.ProductLength.$touch()
                            "
                            v-on:change.native="addDirtyField"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-input-group-text class="standardizedWidth"
                              >Width (inches)</b-input-group-text
                            >
                          </b-input-group-prepend>
                          <b-form-input
                            :class="{
                              my_warning:
                                $v.product.product_edit.ProductWidth.$error
                            }"
                            v-model="product.product_edit.ProductWidth"
                            autocomplete="off"
                            type="text"
                            id="ProductWidth"
                            @input="
                              $v.product.product_edit.ProductWidth.$touch()
                            "
                            v-on:change.native="addDirtyField"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-input-group-text class="standardizedWidth"
                              >Height (inches)</b-input-group-text
                            >
                          </b-input-group-prepend>
                          <b-form-input
                            :class="{
                              my_warning:
                                $v.product.product_edit.ProductHeight.$error
                            }"
                            v-model="product.product_edit.ProductHeight"
                            autocomplete="off"
                            type="text"
                            id="ProductHeight"
                            @input="
                              $v.product.product_edit.ProductHeight.$touch()
                            "
                            v-on:change.native="addDirtyField"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-input-group-text class="standardizedWidth"
                              >Weight (ounces)</b-input-group-text
                            >
                          </b-input-group-prepend>
                          <b-form-input
                            v-model="product.product_edit.ProductWeight"
                            autocomplete="off"
                            type="text"
                            id="ProductWeight"
                            v-mask="'########'"
                            v-on:change.native="addDirtyField"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-image"></i>
                    <span class="ml-1">Images</span>
                  </template>
                  <br />
                  <b-row>
                    <b-col md="12">
                      <ProductImagePreview />
                    </b-col>
                  </b-row>
                  <template>
                    <b-row>
                      <b-col md="12">
                        <b-form-group>
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-button
                                class="standardizedWidth text-left"
                                size="md"
                                variant="primary"
                                @click="$refs.IconLocationFile.click()"
                              >
                                <span v-if="isIconLocationLoading">
                                  <i
                                    class="fa fa-circle-o-notch fa-lg fa-spin"
                                  ></i>
                                  Uploading...
                                </span>
                                <span v-if="!isIconLocationLoading">
                                  <i class="fa fa-cloud-arrow-up mr-1" />
                                  Primary Image
                                </span>
                              </b-button>
                            </b-input-group-prepend>
                            <b-form-input
                              placeholder="No Image Set"
                              v-model="product.product_edit.IconLocation"
                              type="text"
                              autocomplete="off"
                              disabled
                              ref="IconLocationInput"
                            ></b-form-input>
                            <input
                              type="file"
                              @change="
                                onArtworkSelected(
                                  $event,
                                  'IconLocation',
                                  'IconLocationUrl'
                                )
                              "
                              accept=".jpg, .png"
                              id="IconLocation"
                              style="display: none;"
                              ref="IconLocationFile"
                            />
                            <b-input-group-append
                              v-if="product.product_edit.IconLocation"
                            >
                              <b-input-group-text>
                                <i
                                  @click="setSelectedImage('IconLocation')"
                                  v-b-modal.modal-2
                                  class="fa fa-magnifying-glass clickIcon"
                                ></i>
                                <i
                                  @click="resetSelectedImage('IconLocation')"
                                  class="ml-4 fa fa-trash-o appendIcon clickIcon"
                                ></i>
                              </b-input-group-text>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group>
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-button
                                class="standardizedWidth text-left"
                                size="md"
                                variant="primary"
                                @click="$refs.SmallImage1File.click()"
                              >
                                <span v-if="isSmallImage1Loading">
                                  <i
                                    class="fa fa-circle-o-notch fa-lg fa-spin"
                                  ></i>
                                  Uploading...
                                </span>
                                <span v-if="!isSmallImage1Loading">
                                  <i class="fa fa-cloud-arrow-up mr-1" />
                                  Supporting Image
                                </span>
                              </b-button>
                            </b-input-group-prepend>
                            <b-form-input
                              placeholder="No Image Set"
                              v-model="product.product_edit.SmallImage1"
                              type="text"
                              autocomplete="off"
                              disabled
                              ref="SmallImage1Input"
                            ></b-form-input>
                            <input
                              type="file"
                              @change="
                                onArtworkSelected(
                                  $event,
                                  'SmallImage1',
                                  'SmallImage1Url'
                                )
                              "
                              accept=".jpg, .png"
                              id="SmallImage1"
                              style="display: none;"
                              ref="SmallImage1File"
                            />
                            <b-input-group-append
                              v-if="product.product_edit.SmallImage1"
                            >
                              <b-input-group-text>
                                <i
                                  @click="setSelectedImage('SmallImage1')"
                                  v-b-modal.modal-2
                                  class="fa fa-magnifying-glass clickIcon"
                                ></i>
                                <i
                                  @click="resetSelectedImage('SmallImage1')"
                                  class="ml-4 fa fa-trash-o appendIcon clickIcon"
                                ></i>
                              </b-input-group-text>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group>
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-button
                                class="standardizedWidth text-left"
                                size="md"
                                variant="primary"
                                @click="$refs.SmallImage2File.click()"
                              >
                                <span v-if="isSmallImage2Loading">
                                  <i
                                    class="fa fa-circle-o-notch fa-lg fa-spin"
                                  ></i>
                                  Uploading...
                                </span>
                                <span v-if="!isSmallImage2Loading">
                                  <i class="fa fa-cloud-arrow-up mr-1" />
                                  Supporting Image
                                </span>
                              </b-button>
                            </b-input-group-prepend>
                            <b-form-input
                              placeholder="No Image Set"
                              v-model="product.product_edit.SmallImage2"
                              type="text"
                              autocomplete="off"
                              disabled
                              ref="SmallImage2Input"
                            ></b-form-input>
                            <input
                              type="file"
                              @change="
                                onArtworkSelected(
                                  $event,
                                  'SmallImage2',
                                  'SmallImage2Url'
                                )
                              "
                              accept=".jpg, .png"
                              id="SmallImage1"
                              style="display: none;"
                              ref="SmallImage2File"
                            />
                            <b-input-group-append
                              v-if="product.product_edit.SmallImage2"
                            >
                              <b-input-group-text>
                                <i
                                  @click="setSelectedImage('SmallImage2')"
                                  v-b-modal.modal-2
                                  class="fa fa-magnifying-glass clickIcon"
                                ></i>
                                <i
                                  @click="resetSelectedImage('SmallImage2')"
                                  class="ml-4 fa fa-trash-o appendIcon clickIcon"
                                ></i>
                              </b-input-group-text>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group>
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-button
                                class="standardizedWidth text-left"
                                size="md"
                                variant="primary"
                                @click="$refs.SmallImage3File.click()"
                              >
                                <span v-if="isSmallImage3Loading">
                                  <i
                                    class="fa fa-circle-o-notch fa-lg fa-spin"
                                  ></i>
                                  Uploading...
                                </span>
                                <span v-if="!isSmallImage3Loading">
                                  <i class="fa fa-cloud-arrow-up mr-1" />
                                  Supporting Image
                                </span>
                              </b-button>
                            </b-input-group-prepend>
                            <b-form-input
                              placeholder="No Image Set"
                              v-model="product.product_edit.SmallImage3"
                              type="text"
                              autocomplete="off"
                              disabled
                              ref="SmallImage3Input"
                            ></b-form-input>
                            <input
                              type="file"
                              @change="
                                onArtworkSelected(
                                  $event,
                                  'SmallImage3',
                                  'SmallImage3Url'
                                )
                              "
                              accept=".jpg, .png"
                              id="SmallImage3"
                              style="display: none;"
                              ref="SmallImage3File"
                            />
                            <b-input-group-append
                              v-if="product.product_edit.SmallImage3"
                            >
                              <b-input-group-text>
                                <i
                                  @click="setSelectedImage('SmallImage3')"
                                  v-b-modal.modal-2
                                  class="fa fa-magnifying-glass clickIcon"
                                ></i>
                                <i
                                  @click="resetSelectedImage('SmallImage3')"
                                  class="ml-4 fa fa-trash-o appendIcon clickIcon"
                                ></i>
                              </b-input-group-text>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </template>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-tags"></i>
                    <span class="ml-1">Tags</span>
                  </template>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input
                            type="text"
                            placeholder="Search"
                            @keyup="filterList"
                            v-model="searchString"
                          />

                          <b-input-group-append>
                            <b-input-group-text>
                              <i
                                class="fa fa-times appendIcon clickIcon"
                                @click="resetSearch"
                              ></i>
                            </b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <div class="form-group form-actions" style="float:right;">
                        <b-button
                          class="mr-0 "
                          size="md"
                          variant="outline-primary"
                          @click="DashRouteTo('/products/tags')"
                          >Manage Tags</b-button
                        >
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-table
                        @row-clicked="myRowClickHandler"
                        :items="Included"
                        :fields="fields"
                        hover
                        small
                        fixed
                        caption
                        selectable
                        select-mode="single"
                        responsive="sm"
                        selectedVariant="success"
                      >
                        <template slot="Functions2" slot-scope="data">
                          <i
                            v-b-tooltip
                            title="Remove"
                            class="fa fa-minus-circle"
                            @click.stop="SetItemToDelete($event, data.item)"
                          ></i>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-table
                        @row-clicked="myRowClickHandler"
                        :items="NotIncluded"
                        :fields="fields2"
                        hover
                        small
                        fixed
                        caption
                        selectable
                        select-mode="single"
                        responsive="sm"
                        selectedVariant="success"
                      >
                        <template slot="Functions" slot-scope="data">
                          <i
                            v-b-tooltip
                            title="Add"
                            class="fa fa-plus-circle"
                            @click.stop="SetItemToAdd($event, data.item)"
                          ></i>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab v-if="false">
                  <template slot="title">
                    <i class="fa fa-comment-dots"></i>
                    <span class="ml-1">Reviews</span>
                  </template>
                  <br />ADD:
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ImageModal from "@/components/dialogs/ImageModal.vue";
import ProductImagePreview from "@/components/CustomSubComponents/ProductImagePreview.vue";
import ProductTagDialog from "@/components/dialogs/ProductTagModal.vue";

import {
  required,
  email,
  minLength,
  numeric,
  decimal,
  helpers
} from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
import { Switch as cSwitch } from "@coreui/vue";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "ProductProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      isIconLocationLoading: false,
      isSmallImage1Loading: false,
      isSmallImage2Loading: false,
      isSmallImage3Loading: false,
      returnedFileName: "",
      selectedImageUrl: "",
      fields: [
        {
          key: "Functions2",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },

        {
          key: "FullTag.ProductTagName",
          label: "Applied",
          sortable: true
        },
        {
          key: "FullTag.ProductTagDesc",
          label: "Keywords",
          sortable: true
        }
      ],
      fields2: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },

        {
          key: "ProductTagName",
          label: "Available Tags",
          sortable: true
        },
        {
          key: "ProductTagDesc",
          label: "Keywords",
          sortable: true
        }
      ],
      componentKey: 0,
      perPage: 25,
      searchString: ""
    };
  },
  methods: {
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    filterList: function() {
      // this.filteredObjects = this.$store.state.product.products
      //   .filter(
      //     product =>
      //       product.ProductName.toLowerCase().indexOf(
      //         this.searchString.toLowerCase()
      //       ) > -1 ||
      //       product.ProductSku.toLowerCase().indexOf(
      //         this.searchString.toLowerCase()
      //       ) > -1 ||
      //       product.ProductShortDesc.toLowerCase().indexOf(
      //         this.searchString.toLowerCase()
      //       ) > -1 ||
      //       product.ProductDesc.toLowerCase().indexOf(
      //         this.searchString.toLowerCase()
      //       ) > -1 ||
      //       String(product.Active)
      //         .toLowerCase()
      //         .indexOf(this.searchString.toLowerCase()) > -1
      //   )
      //   .filter(
      //     product =>
      //       product.Active == this.selectedStatus || this.selectedStatus == 0
      //   );
    },
    async myRowClickHandler(record, index) {
      await this.$store
        .dispatch("product/loadProductTagEdit", record.ProductTagID)
        .then(() => {
          //alert(this.$store.state.product.transaction_edit.Quantity);
          //this.$router.push({ name: "Product" });
          this.$bvModal.show("modal-4");
        });
    },
    setSelectedImage(_img) {
      if (!_img) {
        return "";
      }
      switch (_img) {
        case "IconLocation":
          this.selectedImageUrl =
            this.$store.state.global.apiResourceUrl +
            this.$store.state.product.product_edit.IconLocation;
          break;
        case "SmallImage1":
          this.selectedImageUrl =
            this.$store.state.global.apiResourceUrl +
            this.$store.state.product.product_edit.SmallImage1;
          break;
        case "SmallImage2":
          this.selectedImageUrl =
            this.$store.state.global.apiResourceUrl +
            this.$store.state.product.product_edit.SmallImage2;
          break;
        case "SmallImage3":
          this.selectedImageUrl =
            this.$store.state.global.apiResourceUrl +
            this.$store.state.product.product_edit.SmallImage3;
          break;
      }
    },
    resetSelectedImage(_img) {
      if (!_img) {
        return "";
      }
      switch (_img) {
        case "IconLocation":
          this.$store.state.product.product_edit.IconLocation = "";
          break;
        case "SmallImage1":
          this.selectedImageUrl = this.$store.state.product.product_edit.SmallImage1 =
            "";
          break;
        case "SmallImage2":
          this.$store.state.product.product_edit.SmallImage2 = "";
          break;
        case "SmallImage3":
          this.$store.state.product.product_edit.SmallImage3 = "";
          break;
      }
    },
    onFileChange() {},
    onFileUpload() {},
    back() {
      this.$router.go(-1);
    },
    async toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    saveTest() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/Save", {
            _saveOp: {
              Url: "/User/SaveUser/",
              Data: {
                _up: this.$store.state.n_user.n_user_edit,
                _newValues: this.dirtyFields,
                ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
              }
            }
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    save() {
      //console.log(this.dirtyFields);
      if (
        this.$store.state.product.product_edit.ProductID === -1 &&
        this.$store.state.product.products.find(
          product =>
            product.ProductName.toLowerCase() ===
            this.$store.state.product.product_edit.ProductName.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    saveField: function(_op) {
      this.$store.dispatch("global/SaveField", _op).then();
    },
    async onArtworkSelected(event, directory, ref) {
      const file = event.target.files[0];

      // const fr = new FileReader();
      // fr.addEventListener("load", () => {
      //   this.imageUrl = fr.result;
      // });
      // fr.readAsDataURL(file);
      // this.image = file;
      switch (ref) {
        case "IconLocationUrl":
          this.isIconLocationLoading = true;
          break;
        case "SmallImage1Url":
          this.isSmallImage1Loading = true;
          break;
        case "SmallImage2Url":
          this.isSmallImage2Loading = true;
          break;
        case "SmallImage3Url":
          this.isSmallImage3Loading = true;
          break;
        default:
      }

      await this.$store
        .dispatch("product/uploadProduct", {
          file
        })
        .then(response => {
          this.returnedFileName = response;
        });

      // _returnedFileName = this.$store.dispatch("product/uploadProduct", {
      //   file
      // });

      // //storageRef.put(file).then(() => {
      //      this.addPermanentLink(directory + "/" + file.name, ref);

      //this.setDirtyField(event.target.id, file.name);

      switch (ref) {
        case "IconLocationUrl":
          this.$store.state.product.product_edit.IconLocation = this.returnedFileName;
          this.isIconLocationLoading = false;
          break;
        case "SmallImage1Url":
          this.$store.state.product.product_edit.SmallImage1 = this.returnedFileName;
          this.isSmallImage1Loading = false;
          break;
        case "SmallImage2Url":
          this.$store.state.product.product_edit.SmallImage2 = this.returnedFileName;
          this.isSmallImage2Loading = false;
          break;
        case "SmallImage3Url":
          this.$store.state.product.product_edit.SmallImage3 = this.returnedFileName;
          this.isSmallImage3Loading = false;
          break;

        default:
      }
      //);
    },
    DashRouteTo(_page) {
      this.$router.push(_page);
    },

    async SetItemToDelete(evt, object) {
      var _op = {
        TaggedID: object.TaggedID,
        ProductID: this.$store.state.product.product_edit.ProductID,
        ProductTagID: object.ProductTagID,
        IsAdd: false
      };
      await this.$store.dispatch("product/updateTagMap", _op);

      this.$store.state.product.product_edit.Tags = this.$store.state.product.product_edit.Tags.filter(
        t => t.ProductTagID !== object.ProductTagID
      );

      //  var _op =
      //  {
      //     CostCenterGroupID: this.$store.state.admin.costcentergroup_edit.CostCenterGroupID,
      //     CostCenterCode: object.CostCenterCode,
      //     Include: false
      //  }
      // this.$store
      //     .dispatch("admin/resolveCostCenterGroupMember", _op)
      //     .then();
    },
    async SetItemToAdd(evt, object) {
      var _newTaggedID;
      var _op = {
        TaggedID: -1,
        ProductID: this.$store.state.product.product_edit.ProductID,
        ProductTagID: object.ProductTagID,
        IsAdd: true
      };
      await this.$store.dispatch("product/updateTagMap", _op).then(response => {
        _newTaggedID = response.data["UpdateTagMapResult"];
      });

      var _added = {
        ProductID: this.$store.state.product.product_edit.ProductID,
        FullTag: object,
        TaggedID: _newTaggedID,
        ProductTagID: object.ProductTagID
      };
      this.$store.state.product.product_edit.Tags.push(_added);

      //       CostCenter: object
      //       };
      //  this.$store.state.admin.costcentergroup_edit.GroupMembers.push(_added);
      //  var _op =
      //  {
      //     CostCenterGroupID: this.$store.state.admin.costcentergroup_edit.CostCenterGroupID,
      //     CostCenterCode: object.CostCenterCode,
      //     Include: true
      //  }
      // this.$store
      //     .dispatch("admin/resolveCostCenterGroupMember", _op)
      //     .then();
    },
    async myLoadComponent() {
      await this.$store.dispatch("product/fetchProductTags");
    }
  },
  mounted() {
    this.$store.state.saveOp.localUrl = "/Product/SaveProduct/";
    this.$store.state.saveOp.localVariableName = "_p";
    this.$store.state.saveOp.localVariableObject = this.$store.state.product.product_edit;
    this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    this.$store.state.saveOp.localFieldToSet = "ProductID";
    this.$store.state.saveOp.localReturnObject = "SaveProductResult";
  },
  computed: {
    ...mapState(["product", "saveOp", "global"]),
    ...mapActions("product", ["Save"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    ShortDescRemaining() {
      if (!this.$store.state.product.product_edit.ProductShortDesc) {
        return 100;
      }
      return (
        100 - this.$store.state.product.product_edit.ProductShortDesc.length
      );
    },
    LongDescRemaining() {
      if (!this.$store.state.product.product_edit.ProductDesc) {
        return 500;
      }
      return 500 - this.$store.state.product.product_edit.ProductDesc.length;
    },
    NotIncluded() {
      var _ni = this.$store.state.product.product_tags;
      this.$store.state.product.product_edit.Tags.forEach(ptm => {
        _ni = _ni.filter(ni => ni.ProductTagID != ptm.ProductTagID);
      });
      return _ni.filter(
        tag =>
          tag.ProductTagDesc.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          tag.ProductTagName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    Included() {
      // console.log("at included");
      //console.log(this.$store.state.product.product_edit.Tags);
      return this.$store.state.product.product_edit.Tags.filter(
        tag =>
          tag.FullTag.ProductTagDesc.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          tag.FullTag.ProductTagName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    }
  },
  components: {
    CoolSelect,
    cSwitch,
    ImageModal,
    ProductImagePreview,
    ProductTagDialog
  },
  validations: {
    product: {
      product_edit: {
        ProductName: {
          required
          //minLength: minLength(7)
        },
        ProductSku: {
          required
          //minLength: minLength(7)
        },
        BaseUnitCost: {
          required
          //minLength: minLength(7)
        },
        WholesaleUnitCost: {
          required,
          decimal
          //minLength: minLength(7)
        },
        ProductHeight: {
          decimal
        },
        ProductWidth: {
          decimal
        },
        ProductLength: {
          decimal
        }
      }
    }
  },
  watch: {
    "$store.state.product.product_edit.Active": function() {
      this.addDirtyFieldWatch(
        "Active",
        this.$store.state.product.product_edit.Active
      );
    },
    "$store.state.product.product_edit.IconLocation": function(newValue) {
      // this.addDirtyFieldWatch(
      //   "IconLocation",
      //   this.$store.state.product.product_edit.IconLocation
      // );
      var _operation = {
        ObjectName: "Product",
        PK: this.$store.state.product.product_edit.ProductID,
        FieldToSet: "IconLocation",
        ValueToSet: newValue
      };
      this.saveField(_operation);
    },
    "$store.state.product.product_edit.SmallImage1": function(newValue) {
      // this.addDirtyFieldWatch(
      //   "IconLocation",
      //   this.$store.state.product.product_edit.IconLocation
      // );
      var _operation = {
        ObjectName: "Product",
        PK: this.$store.state.product.product_edit.ProductID,
        FieldToSet: "SmallImage1",
        ValueToSet: newValue
      };
      this.saveField(_operation);
    },
    "$store.state.product.product_edit.SmallImage2": function(newValue) {
      // this.addDirtyFieldWatch(
      //   "IconLocation",
      //   this.$store.state.product.product_edit.IconLocation
      // );
      var _operation = {
        ObjectName: "Product",
        PK: this.$store.state.product.product_edit.ProductID,
        FieldToSet: "SmallImage2",
        ValueToSet: newValue
      };
      this.saveField(_operation);
    },
    "$store.state.product.product_edit.SmallImage3": function(newValue) {
      // this.addDirtyFieldWatch(
      //   "IconLocation",
      //   this.$store.state.product.product_edit.IconLocation
      // );
      var _operation = {
        ObjectName: "Product",
        PK: this.$store.state.product.product_edit.ProductID,
        FieldToSet: "SmallImage3",
        ValueToSet: newValue
      };
      this.saveField(_operation);
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.my_warning {
  color: red;
  border-color: red;
}
</style>
